import { gql } from '@apollo/client';

export const CALCULATE_BASELINE_OR_TARGET_VALUE = gql`
  query CalculateBaseOrTargetValue($input: CalculateBaseOrTargetValueInput) {
    baselineOrTarget: calculateBaseOrTargetValue(input: $input) {
      value
    }
  }
`;
